import { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, getMe, setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = admin

  useEffect(() => {
    if (!getToken()) return setUser(false);
    getMe()
      .then(setUser)
      .catch(() => { setToken(null); setUser(false); });
  }, []);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const signOut = () => { setToken(null); setUser(false); };

  return <AuthContext.Provider value={{ user, setUser, signIn, signOut }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
